import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Dr. Sayuja Clinic',
    description: 'Dental patient management for Dr. Sayuja Clinic: patient records, consultations, prescriptions and follow-ups in one connected workflow.',
    placeholder: 'Loading patient records',
    url: getOrigin()
}
